// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"8de50123","515":"30b4a4e2","787":"155e0f01","829":"1519562d","956":"35d6d138"}[chunkId] + ".chunk.js";
};